<div id="teacher-dialog">
  {{ "teacher-image-advices-dialog-1" | translate }}
  <ul>
    <li>
      {{ "teacher-image-advices-dialog-2" | translate }}
    </li>
    <li>
      {{ "teacher-image-advices-dialog-3" | translate }}
    </li>
    <li>
      {{ "teacher-image-advices-dialog-4" | translate }}
    </li>
    <li>
      {{ "teacher-image-advices-dialog-5" | translate }}
    </li>
    <li>
      {{ "teacher-image-advices-dialog-6" | translate }}
    </li>
    <li>
      {{ "teacher-image-advices-dialog-7" | translate }}
    </li>
  </ul>
</div>
